  <!-- <div class="row">
    <div class="col-xl-12 col-lg-12">
      <div class="card widget-flat text-white mb-0">
        <div
          class="card-body"
          style=" color: black !important"
        >
          <h5 class="font-weight-normal text-white mt-0" title="Revenue">
            Vault
          </h5>
          <ul class="list-unstyled">
            <li class="d-flex" *ngFor="let deps of plan">
              <i class="fa fa-btc me-3"></i>
              <div class="flex-grow-1">
                <h5 class="mt-3 text-white">
                  ${{ deps.amount }} {{ deps.plan }}
                </h5>
              </div>
              <div class="text-right text-white">
                <h5>{{ deps.current_amount }} USD</h5>
                <div class="progress">
                  <div
                    class="progress-bar"
                    style="background-color: #e73c3e !important"
                    role="progressbar"
                    [style.width]="deps.per + '%'"
                    aria-valuemin="0"
                    aria-valuemax="100"
                  ></div>
                </div>
                <p class="text-success">
                  {{ deps.per }}% <span><i class="las la-arrow-up"></i></span>
                </p>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div> -->



  <section class="plans-wrap">

    <h3  style="color: black; font-weight: normal; margin-bottom: 10px;" title="Revenue">
            Vault
    </h3>

  <div class="plans-grid">
    <!-- CARD -->
    <article class="plan-card" *ngFor="let deps of plan">
      <div class="plan-img">
        <img src="https://laap.org/img/1g.webp" alt="Starter Gold" />
      </div>

      <div class="plan-body">
        <h3 class="plan-title">
          <span class="badge" aria-hidden="true">🏅</span>
          {{deps.plan}}
        </h3>

        <p class="plan-price">Price: <strong>{{deps.amount | currency}}</strong></p>

        <ul class="plan-meta">
          <li><span>Current profit:</span> <strong>{{deps.current_amount | currency}}</strong></li>
          <li><span>Duration:</span> <strong>{{deps.duration}} day (s)</strong></li>
          <li><span>Return on Gold:</span> <strong>{{deps.expected_roi | currency}}</strong></li>
        </ul>
      </div>


      <div class="progress" style="height: 30px; position: relative;">
          <div
                    class="progress-bar"
              style="background-color: #c9963b !important"
              role="progressbar"
              [style.width]="deps.per + '%'"
              aria-valuemin="0"
              aria-valuemax="100"
          >
        </div>
        <span style="position: absolute; left: 50%; top: 50%; transform: translate(-50%, -50%);">{{deps.per}}%</span>
      </div>
    </article>

  </div>
</section>
